import { RouteObject } from 'react-router-dom'
import { PayrollPage } from './payroll'
import { Overtime } from './overtime'
import { Workgroup } from './workgroup'
import { Location } from './location'

export const PayrollRoute: RouteObject = {
    path: '/payroll',
    element: <PayrollPage />,
    children: [
        { index: true, element: <Location /> },
        { path: 'location', element: <Location /> },
        { path: 'monthly', element: <Location /> },
        { path: 'workgroup', element: <Workgroup /> },
        { path: 'overtime', element: <Overtime /> },
    ],
}
